<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--project-edit">
    <!-- メインコンテンツエリア -->
    <main class="l-main">
      <!-- パンくずリスト -->
      <breadcrumb :breadcrumb-data="breadcrumbData" />
      <!-- /パンくずリスト -->

      <!-- メインコンテンツ: 上段共通エリア -->
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">プロジェクトの作成・編集</div>
        </div>
      </div>
      <!-- /メインコンテンツ: 上段共通エリア -->

      <form>
        <!-- システム管理者のみ -->
        <div v-show="adminEdit" class="l-main-content">
          <div class="p-project-edit">
            <div class="c-title c-title--left">
              <div class="c-title__text u-fs24"></div><br />
            </div>
            <div class="p-project-edit-list p-project-edit-list--first">
              <div class="p-project-edit-list__item">
                <div class="c-input__title">メインカテゴリを設定する</div>
                <select-text
                  ref="mainCategorySelect"
                  input-name="main-category-select"
                  place-holder="カテゴリ名を選択してください"
                  :classes="['u-w450']"
                  :elements="categories.main"
                  :value="projectData.category"
                  @select="onSelectCategory"
                />
              </div>
              <div class="p-project-edit-list__item">
                <div class="c-input__title">サブカテゴリを設定する</div>
                <select-text
                  ref="subCategorySelect"
                  input-name="sub-category-select"
                  place-holder="サブカテゴリ名を選択してください"
                  :classes="['u-w450']"
                  :elements="categories.sub"
                  :value="projectData.subCategory"
                  @select="onSelectSubCategory"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- プロジェクト内容の入力フォーム -->
        <div class="l-main-content">
          <div class="p-project-edit">
            <!-- 入力 | 選択リスト -->
            <ul class="p-project-edit-list">
              <!-- プロジェクト名 -->
              <li class="p-project-edit-list__item">
                <ValidatableTextInput
                  :title="'プロジェクト名'"
                  :placeholder="'プロジェクト名を入力してください'"
                  :data="project.name"
                  :error-message="getErrorMessage('project.name')"
                  @value-changed="project.name = $event"
                />
              </li>
              <!-- /プロジェクト名 -->

              <!-- ご利用サイトドメイン -->
              <li v-show="useFirebase" class="p-project-edit-list__item">
                <ValidatableTextInput
                  :title="'ご利用サイトドメイン'"
                  :description="'プッシュ通知の許可を取得するドメイン（サイトURL）を記載下さい。'"
                  :placeholder="'例）https://webpush.jp/'"
                  :data="project.domain"
                  :error-message="getErrorMessage('project.domain')"
                  @value-changed="project.domain = $event"
                />
              </li>
              <!-- /ご利用サイトドメイン -->

              <!-- プッシュ対象の選択 -->
              <li class="p-project-edit-list__item">
                <div class="c-checkbox">
                  <div class="c-checkbox__title">プッシュ対象</div>
                  <ul class="c-checkbox-list">
                    <li v-show="projectData.isNew || (projectData.types && projectData.types[2])" class="c-checkbox-list__item">
                      <label class="c-checkbox__label">
                        <input
                          v-if="projectData.isNew || projectData.types && projectData.types[2]"
                          type="checkbox"
                          name="push_type"
                          value="2"
                          checked="checked"
                          disabled
                        />
                        <input
                          v-else
                          v-model="types"
                          type="checkbox"
                          name="push_type"
                          value="2"
                          @change="onChangePushType()"
                        />
                        <div class="c-checkbox__item">
                          <div class="c-checkbox__box"></div>
                          <div class="c-checkbox__box-label">ブラウザプッシュ</div>
                        </div>
                        <div class="c-checkbox__text">ブラウザプッシュとは、Webサイトアクセス時に通知を許可したユーザーへアプリ同様のプッシュ通知が行えます。通知許可を行ったユーザーにはWebサイトへアクセスしていないタイミングでも通知を送ることができます。</div>
                      </label>
                    </li>
                  </ul>
                  <div class="c-error c-error--balloon c-error--push-type"><div class="c-error__text"></div></div>
                </div>
              </li>
              <!-- /プッシュ対象の選択 -->

              <!-- メッセージアイコン -->
              <li v-show="useFirebase" class="p-project-edit-list__item">
                <div class="c-upload">
                  <div class="c-upload__title">メッセージアイコン</div>
                  <div class="c-upload__text">プッシュ通知メッセージの際にデフォルトで設定される画像のアイコンになります。</div>
                  <label class="c-upload__label">
                    <div class="c-upload__image">
                      <img v-show="iconImage && iconImage != ''" :src="iconImage" />
                      <div v-show="!iconImage" class="c-upload__noimage">
                        <div class="c-icon c-icon--gray-3 u-wh30">
                          <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <use xlink:href="/assets/img/sprite.svg#photo" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="c-upload__data">
                      <input
                        type="file"
                        name="message_icon"
                        value=""
                        placeholder="ファイルの選択"
                        @change="onFileChange"
                      />
                      <span class="c-upload__btn">ファイルの選択</span>
                      <div class="c-upload__text c-upload__text--spec">
                        ※サイズは縦x横：64x64px～192x192px、容量：5KB以内奨励(最大8KB)、形式：PNG奨励(JPG,JPEG可)</div>
                    </div>
                  </label>
                  <div class="c-error c-error--balloon c-error--upload-icon" :class="{'is-active': getErrorMessage('attachement.data')}">
                    <div class="c-error__text">{{ getErrorMessage('attachement.data') }}</div>
                  </div>
                </div>
              </li>
              <!-- /メッセージアイコン -->
              <!-- バッジ画像 -->
              <li v-show="useFirebase" class="p-project-edit-list__item">
                <div class="c-upload">
                  <div class="c-upload__title">ステータスアイコン</div>
                  <div class="c-upload__text">通知受信時に通常はChromeアイコンになりますがアイコンを登録することで、オリジナルのアイコンを表示頂けます。</div>
                  <div class="c-upload__text">※ステータスアイコンはpng画像の非透過領域がシルエットで反映されます。端末によってはモノクロで表示されます。</div>
                  <label class="c-upload__label">
                    <div class="c-upload__image">
                      <img v-show="badgeImage && badgeImage != ''" :src="badgeImage" class="uploaded_transparent_image" />
                      <div v-show="!badgeImage" class="c-upload__noimage">
                        <div class="c-icon c-icon--gray-3 u-wh30">
                          <svg
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <use xlink:href="/assets/img/sprite.svg#photo" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="c-upload__data">
                      <input
                        type="file"
                        name="message_badge"
                        value=""
                        placeholder="ファイルの選択"
                        @change="onBadgeFileChange"
                      />
                      <span class="c-upload__btn">ファイルの選択</span>
                      <div class="c-upload__text c-upload__text--spec">
                        ※サイズは縦x横：72x72px～128x128px、容量：5KB以内奨励(最大8KB)、形式：PNG
                      </div>
                    </div>
                  </label>
                  <span class="c-upload__btn" style="position: relative; top: -92px; left: 270px; cursor: pointer;" @click="clearBadgeFile">クリア</span>

                  <div class="c-error c-error--balloon c-error--upload-badge" :class="{'is-active': getErrorMessage('attachementBadge.data')}">
                    <div class="c-error__text">{{ getErrorMessage('attachementBadge.data') }}</div>
                  </div>
                </div>
              </li>
              <!-- /バッジ画像 -->
            </ul>
            <!-- /入力 | 選択リスト -->
          </div>
        </div>
        <!-- /プロジェクト内容の入力フォーム -->

        <!-- Firebase情報 -->
        <div v-show="useFirebase" class="l-main-content">
          <div class="p-project-edit p-project-edit--readonly p-project-edit--firebase">
            <div class="c-title c-title--left">
              <div class="c-image u-w230"><img src="/assets/img/logo-firebase--standard.svg" /></div>
              <div class="c-text">Google Firebase と連携している設定情報を表示しています</div>
              <GrayButton
                v-show="isEditableFirebase"
                :text="'Firebaseからコピー'"
                :add-style="'width:300px;'"
                @button-click="showCopyPopup"
              />
            </div>
            <!-- リードオンリーリスト -->
            <ul class="p-project-edit-list">
              <li class="p-project-edit-list__item">
                <ValidatableTextInput
                  ref="senderId"
                  :title="'送信者ID'"
                  :is-horizontal="true"
                  :is-readonly="!isEditableFirebase"
                  :data="firebase.senderId"
                  :error-message="getErrorMessage('firebase.senderId')"
                  @value-changed="firebase.senderId = $event; toggleIsChangedFirebase()"
                />
              </li>
              <li class="p-project-edit-list__item">
                <ValidatableTextInput
                  ref="apiKey"
                  :title="'APIKey'"
                  :is-horizontal="true"
                  :is-readonly="!isEditableFirebase"
                  :data="firebase.apiKey"
                  :error-message="getErrorMessage('firebase.apiKey')"
                  @value-changed="firebase.apiKey = $event; toggleIsChangedFirebase()"
                />
              </li>
              <li class="p-project-edit-list__item">
                <ValidatableTextInput
                  ref="projectId"
                  :title="'プロジェクトID'"
                  :is-horizontal="true"
                  :is-readonly="!isEditableFirebase"
                  :data="firebase.projectId"
                  :error-message="getErrorMessage('firebase.projectId')"
                  @value-changed="firebase.projectId = $event; toggleIsChangedFirebase()"
                />
              </li>
              <li class="p-project-edit-list__item">
                <ValidatableTextInput
                  ref="appId"
                  :title="'アプリID'"
                  :is-horizontal="true"
                  :is-readonly="!isEditableFirebase"
                  :data="firebase.appId"
                  :error-message="getErrorMessage('firebase.appId')"
                  @value-changed="firebase.appId = $event; toggleIsChangedFirebase()"
                />
              </li>

              <li class="p-project-edit-list__item">
                <FirebaseServiceKeyInput
                  :is-new="projectData.isNew"
                  :service-account-key="firebase.serviceAccountKey"
                  :error-message="getErrorMessage('firebase.serviceAccountKey')"
                  :is-editable="isEditableFirebase"
                  @service-account-changed="firebase.serviceAccountKey = $event; toggleIsChangedFirebase()"
                />
              </li>
              <li class="p-project-edit-list__item">
                <ValidatableTextInput
                  :title="'ウェブプッシュ証明書\n（鍵ペア）'"
                  :is-horizontal="true"
                  :is-readonly="!isEditableFirebase"
                  :data="firebase.vapId"
                  :error-message="getErrorMessage('firebase.vapId')"
                  @value-changed="firebase.vapId = $event; toggleIsChangedFirebase()"
                />
              </li>
            </ul>
            <!-- /リードオンリーリスト -->
            <div v-if="!isNewPage" class="p-project-edit p-project-edit--firebase__btns">
              <RedButton
                v-if="isEditableFirebase"
                :text="'Firebase設定の編集を終了する'"
                :add-style="'width:300px;'"
                @button-click="isEditMode = false"
              />
              <GrayButton
                v-else
                :text="'Firebase設定を編集する'"
                :add-style="'width:300px;'"
                @button-click="isEditMode = true"
              />
            </div>
          </div>
        </div>
        <!-- /プロジェクト内容の入力フォーム: Firebase -->

        <!-- ボタンエリア -->
        <div class="l-main-content">
          <div class="p-project-btns">
            <a class="c-btn c-btn--gray u-w320 u-h50 u-fs--xl" @click="onCancelCancelBtn">
              <p class="c-btn__text">キャンセル</p>
            </a>
            <button
              class="c-btn c-btn--modal c-btn--blue u-w320 u-h50 u-fs--xl"
              :class="{ 'is-loading': isLoading }"
              :disabled="isLoading"
              type="button"
              name="edit"
              value="edit"
              @click="isChangedFirebase ? showConfirmFirebaseModal = true : save($event)"
            >
              <p class="c-btn__text">編集した内容を保存する</p>
            </button>
          </div>
        </div>
        <!-- /ボタンエリア -->
        <div v-show="!isProduction">
          <a :href="'/testpage/' + projectData.accessToken" target="_blank">テストページへ</a>
        </div>
      </form>
    </main>
    <FirebaseCopyPopup ref="popup" @apply-config="applyFirebaseConfig($event)" />
    <!-- モーダル: Firebase更新確認 -->
    <control-modal
      ref="refConfirmFirebase"
      classes="c-modal--firebase-alert"
      title="注意！"
      :body="confirmFirebaseAlert"
      :is-body-html=true
      cancel-button-label="キャンセル"
      enter-button-label="保存する"
      :is-active="showConfirmFirebaseModal"
      :on-close-click="() => showConfirmFirebaseModal = false"
      :on-cancel-click="() => showConfirmFirebaseModal = false"
      :on-enter-click="save"
    />
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message="'入力を確認してください'"
      :on-close-click="() => isError = false"
    />
  </div>
</template>

<script>
import axios from 'axios';
import GrayButton from '../atoms/GrayButton.vue';
import RedButton from '../atoms/RedButton.vue';
import FirebaseCopyPopup from '../organisms/FirebaseCopyPopup.vue';
import ValidatableTextInput from '../molecules/ValidatableTextInput.vue';
import '../organisms/TagModule.vue';
import ControlModal from '../molecules/ControlModal.vue';
export default {
  components: {
    GrayButton,
    FirebaseCopyPopup,
    ValidatableTextInput,

    ControlModal,
    RedButton,
  },
  props: {
    breadcrumbData: Array,
    projectData: Object,
    linkUrl: String,
    linkText: String,
    categories: Object,
    adminEdit: Boolean,
    isProduction: Boolean,
  },
  data: function () {
    return {
      isLoading: false,
      types:  this.projectData.isNew ? ['2'] : [],
      dmp: Boolean,

      project: {
        name: this.projectData.name || '',
        domain: this.projectData.defaultUrl || ''
      },
      firebase: {
        senderId: this.projectData.senderId || '',
        serviceAccountKey: this.projectData.serviceAccountKey || '',
        vapId: this.projectData.vapId || '',
        apiKey: this.projectData.apiKey || '',
        projectId: this.projectData.projectId || '',
        appId: this.projectData.appId || ''
      },
      attachement: {
        data: '',
        name: '',
        url: this.projectData.defaultImageUrl || ''
      },
      attachementBadge: {
        data: '',
        name: '',
        url: this.projectData.defaultBadgeUrl || ''
      },
      category: {
        main: this.projectData.category,
        sub: this.projectData.subCategory
      },
      errors: {},
      useFirebase: false,
      acceptableMimeTypes: [
        'image/png',
        'image/jpeg',
        'image/gif',
      ],
      isEditMode: false,
      isChangedFirebase: false,
      showConfirmFirebaseModal: false,
      confirmFirebaseAlert: `
                <div>
                    <p>Firebaseの設定情報を変更しようとしています。</p>
                    <p>
                        この設定を誤って変更すると、PUSH ONEの機能に影響を及ぼし、
                        <br />
                        プロジェクトの運用に支障をきたす可能性があります。
                        <br />
                        <br />
                        設定変更を行う前に、以下の点を再確認してください。
                    </p>
                    <ol style="padding: 10px 30px; list-style-type: decimal">
                        <li>変更内容が正しいかどうか</li>
                        <li>他の関係者と確認が取れているか</li>
                        <li>設定変更が即座にプロジェクトに反映されることを理解しているか</li>
                    </ol>
                    <p style="color: red; font-weight: bold">
                        ※特に<strong>ウェブプッシュ証明書(鍵ペア)</strong>の設定を誤るケースが多発しています。
                        <br />
                        &nbsp;&nbsp;&nbsp;正確に入力されているかどうかを十分にご確認ください。
                    </p>
                </div>
                <br />
                <p style="text-align: center">
                    <strong>本当に変更を保存してもよろしいですか？</strong>
                </p>`,
      isError: false,
    }
  },
  computed: {
    iconImage: function () {
      return this.attachement.data || this.attachement.url;
    },
    badgeImage: function () {
      return this.attachementBadge.data || this.attachementBadge.url;
    },
    isEditableFirebase: function () {
      return this.isNewPage || this.isEditMode;
    },
    isNewPage: function () {
      return location.pathname.endsWith('/project/edit/new')
    },
  },
  mounted: function () {
    for (let type in this.projectData.types) {
      if(this.projectData.types[type]){
        this.types.push(type);
      }
    }
    this.dmp = this.projectData.dmp;
    this.onChangePushType();
  },
  methods: {
    isAcceptableMimeType: function(mimeType){
      var isAcceptable = false;
      this.acceptableMimeTypes.forEach(function(acceptableMimeType) {
        if(acceptableMimeType == mimeType){
          isAcceptable = true;
        }
      });
      return isAcceptable;
    },
    onFileChange: function (event) {
      const file = event.target.files[0];
      delete this.errors['attachement.data'];

      if(!this.isAcceptableMimeType(file.type)){
        this.errors['attachement.data'] = ['メッセージアイコンはPNG/JPEG/GIF形式のファイルを指定してください。'];
        this.$forceUpdate();
        return;
      }

      const fileReader = new FileReader();
      const self = this;

      fileReader.onload = () => {
        const offset = fileReader.result.indexOf(",") + 1;
        const base64 = fileReader.result.slice(offset);
        const data = `data:${file.type};base64,${base64}`;
        const params = {
          data: data,
          max_size: 192,
          max_bytes: 8192
        }

        self.optimizeImage(params, function(optimizedImage) {
          if (optimizedImage) {
            if (optimizedImage.filesize > 8192) { // 8KB
              self.errors['attachement.data'] = ['メッセージアイコンは8KB以下のファイルを指定してください。'];
              self.$forceUpdate();
              return;
            }
            self.attachement.data = optimizedImage.data;
          } else {
            if (file.size > 8192) { // 8KB
              self.errors['attachement.data'] = ['メッセージアイコンは8KB以下のファイルを指定してください。'];
              self.$forceUpdate();
              return;
            }
            this.attachement.data = data;
          }
          self.attachement.name = file.name;
        });
      };
      fileReader.readAsDataURL(file);
    },
    onBadgeFileChange: async function (event) {
      const file = event.target.files[0];
      delete this.errors['attachementBadge.data'];

      if(file.type != 'image/png'){
        this.errors['attachementBadge.data'] = ['ステータスアイコンはPNG形式のファイルを指定してください。'];
        this.$forceUpdate();
        return;
      }

      const fileReader = new FileReader();
      const self = this;

      const isTransparency = await self.checkTransparency(file);
      if (!isTransparency) {
        self.errors['attachementBadge.data'] = ['ステータスアイコンは透過PNG形式のファイルを指定してください。'];
        this.$forceUpdate();
        return;
      }

      fileReader.onload = () => {
        const offset = fileReader.result.indexOf(",") + 1;
        const base64 = fileReader.result.slice(offset);
        const data = `data:${file.type};base64,${base64}`;

        const params = {
          data: data,
          max_size: 128,
          max_bytes: 8192
        }
        self.optimizeImage(params, function(optimizedImage) {
          if (optimizedImage) {
            if (optimizedImage.filesize > 8192) { // 8KB
              self.errors['attachementBadge.data'] = ['ステータスアイコンは8KB以下のファイルを指定してください。'];
              self.$forceUpdate();
              return;
            }
            self.attachementBadge.data = optimizedImage.data;
          } else {
            if (file.size > 8192) { // 8KB
              self.errors['attachementBadge.data'] = ['ステータスアイコンは8KB以下のファイルを指定してください。'];
              self.$forceUpdate();
              return;
            }
            this.attachementBadge.data = data;
          }
          self.attachementBadge.name = file.name;
        });
      };
      fileReader.readAsDataURL(file);
    },
    onCancelCancelBtn: function() {
      this.backToPreviousPage();
    },
    save: function () {
      this.isLoading = true;
      const self = this;
      const data = {
        serviceTypes: this.types,
        project: this.project,
        firebase: this.firebase,
        attachement: this.attachement,
        attachementBadge: this.attachementBadge,
        serviceId: this.projectData.serviceId,
        category: this.category,
      }
      axios.post('/api/projects', data)
        .then(_res => {
          location.href = '/coins-admin/project/list';
        })
        .catch(e => {
          self.errors = e.response.data.errors;
          this.isLoading = false;
          this.showConfirmFirebaseModal = false;
          this.isError = true;
        });
    },
    getErrorMessage: function (key) {
      var error = this.errors[key];
      return error ? error[0] : '';
    },
    showCopyPopup: function () {
      this.$refs.popup.open();
    },
    applyFirebaseConfig: function (config) {
      this.$refs.senderId.changeValue(config.messagingSenderId);
      this.$refs.apiKey.changeValue(config.apiKey);
      this.$refs.projectId.changeValue(config.projectId);
      this.$refs.appId.changeValue(config.appId);
    },
    onSelectCategory: function(selected) {
      this.category.main = selected;
    },
    onSelectSubCategory: function(selected) {
      this.category.sub = selected;
    },
    onChangePushType: function() {
      if (this.types.length > 1) {
        this.types.shift();
      }
      this.useFirebase = this.types.includes('2');
    },
    optimizeImage: function(params, callback) {
      const endpoint = 'https://bpjflajowoc3zds6vfdqnhcfs40irvbj.lambda-url.ap-northeast-1.on.aws';
      axios.post(endpoint, params)
        .then(res => {
          callback(res.data);
        })
        .catch(_e => {
          callback(null);
        });
    },
    checkTransparency: async function(file) {
      const image = await this.loadImage(file);
      return await this.checkImageTransparency(image);
    },
    loadImage(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = (e) => reject(e);
          img.src = reader.result;
        };

        reader.onerror = (e) => reject(e);
        reader.readAsDataURL(file);
      });
    },
    checkImageTransparency(img) {
      return new Promise((resolve, _reject) => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const alphaChannel = imageData.data.filter((_, i) => (i + 1) % 4 === 0);

        if (alphaChannel.some((alpha) => alpha !== 255)) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    clearBadgeFile: function () {
      this.attachementBadge.url = '';
      this.attachementBadge.name = '';
      this.attachementBadge.data = '';
    },
    toggleIsChangedFirebase: function () {
      if (!this.isNewPage) {
        this.isChangedFirebase = true
      }
    },
  },
}
</script>

<style scoped>
.uploaded_transparent_image {
    margin: 0;
    padding: 0;
    background-color: #fff;
    background-image: linear-gradient(45deg, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%, #ddd),
    linear-gradient(45deg, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%, #ddd);
    background-size: 18px 18px;
    background-position: 0 0, 9px 9px;
    overflow: hidden;
}
</style>
